import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { OAuthService } from 'angular-oauth2-oidc';

import { IUserInfo } from '../../../../interface/user-info.interface';
import { ModalEnum } from '../../../../app/core/helpers/modal/modal.enum';
import { AnalyticsService } from '../../../../app/core/services/analytics/analytics.service';
import { LoaderProfileService } from '../../../../app/core/services/loader-profile/loader-profile.service';
import { ModalService } from '../../../../app/core/services/modal/modal.service';
import { StoreService } from '../../../../app/core/services/store/store.service';
import { Item } from '../../models/item.model';
import { MenuItemsModel } from '../../models/layout/menu-items.model';
import { ProfileModel } from '../../models/layout/profile.model';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  userInfo: IUserInfo;
  userNameInitials: string;
  userName: string;
  menuItems: Item[];
  show = false;
  menuOpened = false;
  hidden = false;
  MIN_HEIGHT_TO_HIDE_SUBPAGES = 630;
  hideSubpages = window.innerHeight < this.MIN_HEIGHT_TO_HIDE_SUBPAGES;

  constructor(
    private storeService: StoreService,
    private modalService: ModalService,
    private router: Router,
    private oauthService: OAuthService,
    private loader: LoaderProfileService,
    private analyticsService: AnalyticsService
  ) {
    this.getProfileInfo();
    this.getMenuInfo();
  }

  openMenu() {
    this.menuOpened = true;
    this.hidden = true;
  }

  closeMenu() {
    this.menuOpened = false;
    this.hidden = false;
  }

  /**
   * Get user information to populate profile
   */
  getProfileInfo(): void {
    this.loader.denyAccess$.subscribe((x) => {
      if (x) {
        this.show = false;
        return;
      }
      this.storeService.profile.subscribe((profile) => {
        this.userInfo = new ProfileModel(profile);
        this.userName = profile.operador;
        this.userNameInitials = this.getUsernameInitials(profile.operador);
        this.show = true;
      });
    });
  }

  /**
   * Get Menu information to populate header
   */
  getMenuInfo(): void {
    this.loader.denyAccess$.subscribe((x) => {
      if (x) {
        this.show = false;
        return;
      }
      this.storeService.menu.subscribe((menuRoutes) => {
        this.menuItems = new MenuItemsModel(menuRoutes).menuStructure;
        this.show = true;
      });
    });
  }

  /**
   * Handle menu clicks to either redirect to route or open modal
   * @param event
   */
  async goToPage(path: string): Promise<void> {
    this.analyticsService.track({
      analytics: {
        event_name: 'click',
        parameters: {
          custom_path: `/menu/${path}`,
          detail: `menu:${path}`
        }
      }
    });

    if (path.startsWith(ModalEnum.MODAL_PREFIX)) {
      this.modalService.openModal(path.replace(ModalEnum.MODAL_PREFIX, ''));
      // @ts-ignore
      window.scrollWindow();
      return;
    }

    const paths = path.split('?#');
    this.router.navigate([paths[0]], { fragment: paths[1] });
    // @ts-ignore
    window.scrollWindow();
  }

  /**
   * Exits application
   */
  exit(): void {
    const pathNameWithoutBar = document.location.pathname.toLowerCase().replace('/', '');

    this.analyticsService.track({
      analytics: {
        event_name: 'click',
        parameters: {
          custom_path: `menu:${pathNameWithoutBar}`,
          detail: 'menu:sair'
        }
      }
    });

    if (sessionStorage.getItem('authenticator') === 'ISAM') {
      this.oauthService
        .revokeTokenAndLogout()
        .then(() => {
          const logoutUrl = this.oauthService.issuer + '/pkmslogout?filename=PT6_logout.html';
          location.href = logoutUrl;
        })
        .catch();
    } else if (sessionStorage.getItem('authenticator') === 'STS') {
      localStorage.clear();
      sessionStorage.clear();
      location.href = 'https://itau.com.br';
    } else {
      this.oauthService.logOut();
    }
  }

  /**
   * Get username inital to fill menu
   */
  getUsernameInitials(username: string): string {
    const splitedUsername = username.split(' ');
    const firstNameInitial = splitedUsername[0][0];
    const lastNameInitial = splitedUsername[splitedUsername.length - 1][0];

    return firstNameInitial + lastNameInitial;
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    this.hideSubpages = window.innerHeight < this.MIN_HEIGHT_TO_HIDE_SUBPAGES;
  }

  @HostListener('document:mouseleave', ['$event'])
  onMouseLeaveDocument() {
    if (this.menuOpened) {
      this.menuOpened = false;
      this.hidden = false;
    }
  }
}
